<template>
    <div class="vod-conference-preview">
        <div
            class="vod-preview-header"
            :style="{ backgroundImage: `url(${conference.thumbnail})` }"
        >
            <h4>{{ conference.subtitle }}</h4>
            <h1>{{ conference.title }}</h1>
            <p v-html="convertedDescription" />
        </div>
        <div>
            <VodContentCarousel
                :content="conferenceWebinars"
                style="margin-top: -7.5rem;"
            />
        </div>
    </div>
</template>
<script>
import VodContentCarousel from './VodContentCarousel'
export default {
    components: {
        VodContentCarousel
    },
    props: {
        conference: Object
    },
    computed: {
        convertedDescription() {
            const size = 200
            const body = this.conference.description
            if (body.length <= size) {
                return body
            }
            const subString = body.substr(0, size - 1)
            return subString.substr(0, subString.lastIndexOf(' ')) + '&hellip;'
        },
        conferenceWebinars() {
            return this.$store.getters['content/webinarsByConference'](
                this.conference.uuid
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.vod-conference-preview {
    margin: 0 -2rem;
    margin-bottom: 4rem;

    @media (max-width: 1000px) {
        margin: 0;
    }
}
.vod-preview-header {
    position: relative;
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    padding: 3rem 2rem;
    padding-bottom: 10rem;
    font-size: 1.5rem;

    @media (max-width: 1000px) {
        padding-left: 4rem;
        padding-right: 4rem;
        font-size: 1.5rem;
    }

    h4,
    h1,
    p {
        z-index: $low;
        position: relative;
        margin: 0.5rem 0.2rem;
        max-width: 40rem;
    }
    h4 {
        letter-spacing: 0.5rem;
        font-size: 1.3rem;
        margin-left: 0.4rem;
        text-transform: uppercase;
    }
    p {
        font-size: 1.1rem;
        line-height: 1.5rem;
    }
    $background: var(--background);
    &::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 90%;
        height: 100%;
        content: '';
        background: linear-gradient(to left, transparent 40%, $background 90%);
        z-index: 0;
    }
}
@media (max-width: 1000px) {
    .vod-preview-header {
        padding-left: 2rem;
        padding-right: 2rem;
    }
    h1 {
        font-size: 2rem;
        line-height: 2.5rem;
    }
}
</style>
